<div class="content-card">
    <div class="card-inner">
        <p-fluid>
            <div class="font-semibold text-xl mb-4 module-name">
                User Client Assignment List
            </div>
            <p-table #mainTable [value]="viewModel.filteredUserClients()" [rows]="10" [columns]="viewModel.cols"
                [paginator]="true" [globalFilterFields]="['userName', 'clientName']"
                [tableStyle]="{ 'min-width': '50rem' }" [rowHover]="true" dataKey="id"
                currentPageReportField="Showing {first} to {last} of {totalRecords} userClients"
                [showCurrentPageReport]="true" [rowsPerPageOptions]="[10, 20, 30]">
                <ng-template #caption>
                    <div class="flex flex-col justify-between">
                        <!-- Filter Dropdowns -->
                        <div class="flex justify-between gap-4 w-full">
                            <!-- User Name Filter -->
                            <div class="flex flex-col flex-1">
                                <label class="block font-medium mb-2">User Name</label>
                                <p-select id="userFilter" [options]="viewModel.userList()" optionLabel="name"
                                    optionValue="code" [ngModel]="viewModel.selectedUserId()" [filter]="true"
                                    placeholder="Filter by User Name" [showClear]="!!viewModel.selectedUserId()"
                                    (ngModelChange)="viewModel.selectedUserId.set($event)">
                                </p-select>
                            </div>

                            <!-- Client Name Filter -->
                            <div class="flex flex-col flex-1">
                                <label class="block font-medium mb-2">Client Name</label>
                                <p-select id="clientFilter" [options]="viewModel.clientList()" optionLabel="name"
                                    optionValue="code" [ngModel]="viewModel.selectedClientId()" [filter]="true"
                                    placeholder="Filter by Client Name" [showClear]="!!viewModel.selectedClientId()"
                                    (ngModelChange)="viewModel.selectedClientId.set($event)">
                                </p-select>
                            </div>
                        </div>

                        <div class="flex flex-col items-end gap-3 flex-1 mt-4">
                            <div class="flex gap-2">
                                <p-button label="Add" icon="pi pi-plus" severity="info" (click)="viewModel.openNew()" />
                            </div>
                        </div>
                    </div>
                    <div class="flex items-center justify-between mt-4">
                        <h5 class="m-0"></h5>
                        <p-iconfield>
                            <p-inputicon styleClass="pi pi-search" />
                            <input pInputText type="text" (input)="mainTable.filterGlobal($any($event.target).value, 'contains')"
                                placeholder="Search..." />
                        </p-iconfield>
                    </div>
                </ng-template>
                <ng-template #header>
                    <tr>
                        <th pSortableColumn="userName" style="min-width:16rem">
                            User
                            <p-sortIcon field="userName" />
                        </th>
                        <th pSortableColumn="clientName" style="min-width: 16rem">
                            Client
                            <p-sortIcon field="clientName" />
                        </th>
                        <th *ngIf="viewModel.canManageModule">Action</th>
                    </tr>
                </ng-template>
                <ng-template #body let-userClient>
                    <tr>
                        <td style="min-width: 12rem" class="user-link" (click)="viewModel.viewUserClient(userClient)">{{
                            userClient.userName }}</td>
                        <td style="min-width: 16rem">{{ userClient.clientName }}</td>
                        <td *ngIf="viewModel.canManageModule">
                            <p-button icon="pi pi-pencil" severity="info" class="mr-2" [rounded]="true" [outlined]="true"
                                [raised]="true" (click)="viewModel.editUserClient(userClient)" pTooltip="Edit"
                                tooltipPosition="top" />
                            <p-button icon="pi pi-trash" severity="danger" [rounded]="true" [outlined]="true"
                                [raised]="true" (click)="viewModel.deleteUserClient(userClient)" pTooltip="Delete"
                                tooltipPosition="top" />
                        </td>
                    </tr>
                </ng-template>
                <ng-template #emptymessage>
                    <tr>
                        <td [attr.colspan]="viewModel.canManageModule ? 3 : 2" class="noData">No data found.</td>
                    </tr>
                </ng-template>
            </p-table>
        </p-fluid>
        <p-confirmdialog [style]="{ width: '450px' }" [draggable]="false" />

        <p-dialog [(visible)]="viewModel.viewDialog" [appendTo]="'body'" [style]="{ width: '450px' }"
            header="User Client Details" [modal]="true" [dismissableMask]="false" [blockScroll]="true"
            [draggable]="false" styleClass="p-fluid">
            <ng-template #content>
                <div class="field mb-4">
                    <label for="viewUserName" class="font-bold mb-2 block">User Name</label>
                    <input pInputText id="viewUserName" [(ngModel)]="viewModel.selectedUserClientForView.userName"
                        [disabled]="true" class="w-full" />
                </div>
                <div class="field">
                    <label for="viewClientName" class="font-bold mb-2 block">Client Name</label>
                    <input pInputText id="viewClientName" [(ngModel)]="viewModel.selectedUserClientForView.clientName"
                        [disabled]="true" class="w-full" />
                </div>
            </ng-template>
            <ng-template #footer>
                <p-button label="Close" icon="pi pi-times" (click)="viewModel.hideViewDialog()" severity="warn" />
            </ng-template>
        </p-dialog>

        <!-- Create/Edit Dialog -->
        <p-dialog [(visible)]="viewModel.createDialog" [appendTo]="'body'"
            [style]="{ width: '80vw', maxWidth: '1000px' }"
            [contentStyle]="{ 'max-height': '60vh', 'overflow-y': 'auto' }"
            [header]="viewModel.dialogIsEdit() ? 'Edit User Client Assignment' : 'Create User Client Assignment'" [modal]="true"
            [dismissableMask]="false" [blockScroll]="true" [draggable]="false" styleClass="p-fluid">
            <ng-template #content>
                <!-- Assign Type and Filters -->
                <div class="grid gap-4 mb-4 items-end grid-cols-1 md:grid-cols-2">
                    <div class="flex flex-col">
                        <label class="block font-medium mb-2">Assign Type</label>
                        <p-select [options]="viewModel.assignTypeOptions" optionLabel="label" optionValue="value"
                            [ngModel]="viewModel.dlgAssignType()"
                            (ngModelChange)="viewModel.onDialogAssignTypeChange($event)"
                            [ngModelOptions]="{standalone: true}" placeholder="Select Assign Type" [showClear]="false"
                            [disabled]="viewModel.isDialogAssignTypeDisabled()" class="w-full"
                            [style]="{'width':'100%'}">
                        </p-select>
                    </div>

                    <div *ngIf="viewModel.dlgAssignType() === 'client'" class="flex flex-col">
                        <!-- <label class="block font-medium mb-2">Client ({{ viewModel.clientList().length }} available)</label> -->
                        <label class="block font-medium mb-2">Client</label>
                        <p-select [options]="viewModel.clientList()" optionLabel="name" optionValue="code"
                            [ngModel]="viewModel.dlgSelectedClientId()"
                            (ngModelChange)="viewModel.onDialogClientChange($event)"
                            [ngModelOptions]="{standalone: true}" placeholder="Select Client" [showClear]="true"
                            [disabled]="viewModel.isDialogClientDropdownDisabled()" class="w-full"
                            [style]="{'width':'100%'}">
                        </p-select>
                    </div>

                    <div *ngIf="viewModel.dlgAssignType() === 'user'" class="flex flex-col">
                        <!-- <label class="block font-medium mb-2">User ({{ viewModel.userList().length }} available)</label> -->
                        <label class="block font-medium mb-2">User</label>
                        <p-select [options]="viewModel.userList()" optionLabel="name" optionValue="code"
                            [ngModel]="viewModel.dlgSelectedUserId()"
                            (ngModelChange)="viewModel.onDialogUserChange($event)" [ngModelOptions]="{standalone: true}"
                            placeholder="Select User" [showClear]="true"
                            [disabled]="viewModel.isDialogUserDropdownDisabled()" class="w-full"
                            [style]="{'width':'100%'}">
                        </p-select>
                    </div>
                </div>

                <!-- Table: By Client -> Users list with checkbox and Username -->
                <p-table #userTable *ngIf="viewModel.dlgAssignType() === 'client'" [value]="viewModel.userList()"
                    [rows]="10" [paginator]="true" [globalFilterFields]="['name']"
                    [tableStyle]="{ 'min-width': '50rem' }" [rowHover]="true" dataKey="code"
                    [(selection)]="viewModel.dlgUserSelectionRows" selectionMode="multiple"
                    currentPageReportField="Showing {first} to {last} of {totalRecords} users"
                    [showCurrentPageReport]="true" [rowsPerPageOptions]="[10, 20, 30]">
                    <ng-template #caption>
                        <div class="flex items-center justify-between">
                            <h5 class="m-0"></h5>
                            <p-iconfield>
                                <p-inputicon styleClass="pi pi-search" />
                                <input pInputText type="text"
                                    (input)="userTable.filterGlobal($any($event.target).value, 'contains')"
                                    placeholder="Search..." />
                            </p-iconfield>
                        </div>
                    </ng-template>
                    <ng-template #header>
                        <tr>
                            <th style="width:3rem">
                                <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                            </th>
                            <th style="width: auto">Username</th>
                        </tr>
                    </ng-template>
                    <ng-template #body let-row>
                        <tr>
                            <td style="width:3rem">
                                <p-tableCheckbox [value]="row"></p-tableCheckbox>
                            </td>
                            <td>{{ row.name }}</td>
                        </tr>
                    </ng-template>
                    <ng-template #emptymessage>
                        <tr>
                            <td colspan="2" class="noData">No users found.</td>
                        </tr>
                    </ng-template>
                </p-table>

                <!-- Table: By User -> Clients list with checkbox and Clients -->
                <p-table #clientTable *ngIf="viewModel.dlgAssignType() === 'user'" [value]="viewModel.clientList()"
                    [rows]="10" [paginator]="true" [globalFilterFields]="['name']"
                    [tableStyle]="{ 'min-width': '50rem' }" [rowHover]="true" dataKey="code"
                    [(selection)]="viewModel.dlgClientSelectionRows" selectionMode="multiple"
                    currentPageReportField="Showing {first} to {last} of {totalRecords} clients"
                    [showCurrentPageReport]="true" [rowsPerPageOptions]="[10, 20, 30]">
                    <ng-template #caption>
                        <div class="flex items-center justify-between">
                            <h5 class="m-0"></h5>
                            <p-iconfield>
                                <p-inputicon styleClass="pi pi-search" />
                                <input pInputText type="text"
                                    (input)="clientTable.filterGlobal($any($event.target).value, 'contains')"
                                    placeholder="Search..." />
                            </p-iconfield>
                        </div>
                    </ng-template>
                    <ng-template #header>
                        <tr>
                            <th style="width:3rem">
                                <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                            </th>
                            <th style="width: auto">Clients</th>
                        </tr>
                    </ng-template>
                    <ng-template #body let-row>
                        <tr>
                            <td style="width:3rem">
                                <p-tableCheckbox [value]="row"></p-tableCheckbox>
                            </td>
                            <td>{{ row.name }}</td>
                        </tr>
                    </ng-template>
                    <ng-template #emptymessage>
                        <tr>
                            <td colspan="2" class="noData">No clients found.</td>
                        </tr>
                    </ng-template>
                </p-table>

            </ng-template>
            <ng-template #footer>
                <!-- Action Buttons -->
                <div class="flex justify-end gap-2">
                    <p-button label="Cancel" icon="pi pi-times" severity="warn" type="button"
                        (onClick)="viewModel.onCreateDialogClose()"></p-button>
                    <p-button [label]="viewModel.dialogSaveButtonLabel()" icon="pi pi-save" severity="success"
                        [raised]="true" type="button" [disabled]="viewModel.isDialogSaveDisabled()"
                        (onClick)="viewModel.onCreateDialogSave(viewModel.buildDialogPayload())"></p-button>
                </div>
            </ng-template>
        </p-dialog>
    </div>
</div>